import React, { useEffect } from "react";

const Modal = ({
  title,
  children,
  submitLabel,
  onSubmit,
  modalId,
  modalType = "",
  submitDisabled = false,
  onClose,
  headerActions,
  hideFooter = false,
}) => {
  useEffect(() => {
    const modalElement = document.getElementById(modalId);

    const cleanupModalArtifacts = () => {
      const hasOpenModal = document.querySelector('.modal.show');
      if (hasOpenModal) {
        return;
      }

      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    };

    const handleModalHidden = () => {
      cleanupModalArtifacts();
      if (typeof onClose === "function") onClose();
    };

    if (modalElement) {
      modalElement.addEventListener('hidden.bs.modal', handleModalHidden);
      
      return () => {
        modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
        cleanupModalArtifacts();
      };
    }
  }, [modalId, onClose]);

  const handleClose = () => {
    // Prefer using Bootstrap's modal hide API so the library can cleanly remove backdrops
    try {
      const modalElement = document.getElementById(modalId);
      const bs = window.bootstrap;
      if (bs && modalElement) {
        const inst = bs.Modal.getInstance(modalElement) || new bs.Modal(modalElement);
        inst.hide();
        return;
      }
    } catch (err) {
      // ignore and fallback to onClose
    }

    // Fallback: remove modal-open class/styles/backdrops and notify
    if (!document.querySelector('.modal.show')) {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    }
    if (typeof onClose === "function") onClose();
  };

  const dialogStyle =
    typeof modalType === "string" && modalType.includes("modal-xxl")
      ? { maxWidth: "1320px", width: "95vw" }
      : undefined;

  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-hidden="true"
      data-bs-focus="false"
      style={{ zIndex: 2000 }}
    >
      <div className={`modal-dialog ${modalType}`} style={dialogStyle}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <div className="d-flex align-items-center gap-2 ms-auto">
              {headerActions}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
          </div>
          <div className="modal-body">{children}</div>
          {!hideFooter && (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Close
              </button>
              {(
                typeof submitLabel === "string" &&
                submitLabel.trim() !== "" && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onSubmit}
                    disabled={submitDisabled}
                  >
                    {submitLabel}
                  </button>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
